<template>
  <q-btn
    icon="fa fa-plus"
    label="Search"
    color="primary"
    rounded
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostSearch } from '@/type';
import openModal from '@/components/modal';
import CreateSearchModal from './CreateSearchModal.vue';

export default defineComponent({
  emits: ['created'],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        clientId: this.clientId,
      };
      openModal(CreateSearchModal, config)
        .onOk((postSearch: PostSearch) => {
          this.$emit('created', postSearch);
        });
    },
  },
});
</script>
